import { configHome } from "@pub/config";
import placeholders from "@pub/placeholders";
import { AnchorBlock } from "@sphtech/dmg-design-system";
import { HomeLayoutProps } from "@src/app/layouts/Home/Elements/utils";
import styles from "@src/app/layouts/Home/homelayout.module.css";
import cx from "classnames";
import { ReactNode } from "react";

import bannerStyle from "./Home.module.css";

type Props = {
  data: HomeLayoutProps["data"];
};

export default function Banner({ data }: Props): ReactNode {
  if (!data.spotlightStoryProps) {
    return null;
  }

  return (
    <div
      className={cx(
        styles.anchorBlockContainer,
        styles.bodyContainer,
        bannerStyle.homeContentBannerContainer,
      )}
    >
      <AnchorBlock
        {...data.spotlightStoryProps}
        placeholder={placeholders.landscape}
        loading="lazy"
        CustomHeadingElement={"h2"}
        hideBreadCrumb={configHome.anchorBlock?.hideBreadCrumb}
        hideVerticalLine={configHome.anchorBlock?.hideVerticalLine}
        mobileCrop={"landscape"}
        displayPublishDate={configHome.teaser?.displayPublishDate}
        displayType={configHome.anchorBlock?.displayType}
      />
    </div>
  );
}
